import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import Field from '../Field.js';
import FieldGroup, { FieldChoiceGroup } from '../FieldGroup.js';
import { useEffect, useRef } from 'react';
import format from 'date-fns/format';
function Education(t0) {
  const $ = _c(32);
  const {
    terms: t1,
    autoFocus: t2
  } = t0;
  const terms = t1 === undefined ? [] : t1;
  const autoFocus = t2 === undefined ? true : t2;
  const formik = useFormikContext();
  const {
    values,
    setFieldValue
  } = formik;
  let t3;
  if ($[0] !== formik.values.termId) {
    t3 = t => t.id === formik.values.termId;
    $[0] = formik.values.termId;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const term = terms.find(t3);
  const filteredTerms = formik.values.highSchoolGrad === "yes" || formik.values.ged === "yes" ? terms.slice(0, 1) : terms;
  const isMounted = useRef(false);
  const shouldRenderGpaSection = formik.values.ged === "yes" || formik.values.highSchoolGrad === "yes" || formik.values.ged === "no" && formik.values.highSchoolGrad === "no";
  let t4;
  let t5;
  if ($[2] !== setFieldValue || $[3] !== values.ged || $[4] !== values.highSchoolGrad) {
    t4 = () => {
      if (!isMounted.current) {
        return;
      }
      if (values.highSchoolGrad === "yes" && values.ged !== "") {
        setFieldValue("ged", "");
        setFieldValue("gedDate", "");
        setFieldValue("gedPlanned", "");
      } else {
        if (values.highSchoolGrad === "no") {
          setFieldValue("highSchoolGradDate", "");
          setFieldValue("highSchoolName", "");
        } else {
          if (values.ged === "yes") {
            setFieldValue("gedPlanned", "");
          } else {
            if (values.ged === "no") {
              setFieldValue("gedDate", "");
            }
          }
        }
      }
      if (values.highSchoolGrad === "yes" && values.ged !== "" || values.ged === "yes" && values.highSchoolGrad !== "" || values.highSchoolGrad === "no" && values.ged === "no") {
        setFieldValue("nameMatchesGradDocument", "");
        setFieldValue("nameFromGradDocument", "");
      }
    };
    t5 = [values.highSchoolGrad, values.ged, setFieldValue];
    $[2] = setFieldValue;
    $[3] = values.ged;
    $[4] = values.highSchoolGrad;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      isMounted.current = true;
      return () => isMounted.current = false;
    };
    t7 = [];
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  useEffect(t6, t7);
  const termSelect = <FieldGroup label="When do you want to start school?"><Field as="select" name="termId">{filteredTerms.map(_temp)}</Field></FieldGroup>;
  let t8;
  if ($[9] !== autoFocus) {
    t8 = <Field type="radio" name="highSchoolGrad" value="yes" label="Yes" autoFocus={autoFocus} />;
    $[9] = autoFocus;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Field type="radio" name="highSchoolGrad" value="no" label="No" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8) {
    t10 = <FieldChoiceGroup legend="Have you graduated from high school?" name="highSchoolGrad" columns={2}>{t8}{t9}</FieldChoiceGroup>;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = formik.values.highSchoolGrad === "yes" && <><FieldGroup label="When did you graduate?"><Field name="highSchoolGradDate" placeholder="MM/YYYY" formatOptions={{
        date: true,
        datePattern: ["m", "Y"]
      }} /></FieldGroup><FieldGroup label="Which High School did you attend?"><Field name="highSchoolName" /></FieldGroup>{termSelect}</>;
  const t12 = formik.values.highSchoolGrad === "no" && <><FieldChoiceGroup legend="Do you have a GED?" name="ged" columns={2}><Field type="radio" name="ged" value="yes" label="Yes" /><Field type="radio" name="ged" value="no" label="No" /></FieldChoiceGroup>{formik.values.ged === "yes" && <><FieldGroup label="When did you get your GED?"><Field name="gedDate" placeholder="MM/YYYY" formatOptions={{
          date: true,
          datePattern: ["m", "Y"]
        }} /></FieldGroup>{termSelect}</>}{formik.values.ged === "no" && <>{termSelect}{!!formik.values.termId && <FieldChoiceGroup legend={term?.termStartsAt ? `Do you plan to graduate high school or get your GED before ${format(new Date(term.termStartsAt), "MMMM d, yyyy")}?` : "Do you plan to graduate high school or get your GED before the quarter starts?"} name="gedPlanned" columns={2}><Field type="radio" name="gedPlanned" value="yes" label="Yes" /><Field type="radio" name="gedPlanned" value="no" label="No" /></FieldChoiceGroup>}</>}</>;
  let t13;
  if ($[14] !== shouldRenderGpaSection) {
    t13 = shouldRenderGpaSection && <FieldGroup label="What is your High School GPA?"><Field as="select" name="highSchoolGpa"><option value="0.0 - 0.9">0.0 - 0.9</option><option value="1.0 - 1.9">1.0 - 1.9</option><option value="2.0 - 2.9">2.0 - 2.9</option><option value="3.0 - 3.9">3.0 - 3.9</option><option value="4.0 +">4.0 +</option><option value="I don't know">{"I don't know"}</option></Field></FieldGroup>;
    $[14] = shouldRenderGpaSection;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== formik.values.firstName || $[17] !== formik.values.ged || $[18] !== formik.values.highSchoolGrad || $[19] !== formik.values.lastName) {
    t14 = (formik.values.ged === "yes" || formik.values.highSchoolGrad === "yes") && <FieldChoiceGroup legend={<>Does your name appear as{" "}<b>{formik.values.firstName} {formik.values.lastName}</b>{" "}exactly on your{" "}{formik.values.ged === "yes" ? "GED certificate" : "High School diploma"}?</>} name="nameMatchesGradDocument" columns={2}><Field type="radio" name="nameMatchesGradDocument" value="yes" label="Yes" /><Field type="radio" name="nameMatchesGradDocument" value="no" label="No" /></FieldChoiceGroup>;
    $[16] = formik.values.firstName;
    $[17] = formik.values.ged;
    $[18] = formik.values.highSchoolGrad;
    $[19] = formik.values.lastName;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== formik.values.ged || $[22] !== formik.values.nameMatchesGradDocument) {
    t15 = formik.values.nameMatchesGradDocument === "no" && <FieldGroup label={<>What name appears on your{" "}{formik.values.ged === "yes" ? "GED certificate" : "High School diploma"}?</>}><Field name="nameFromGradDocument" /></FieldGroup>;
    $[21] = formik.values.ged;
    $[22] = formik.values.nameMatchesGradDocument;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FieldGroup label="Do you have experience using online learning tools (video chat, online learning software, etc)? How confident are you in using these tools independently?"><Field as="select" name="distanceEducation"><option value="noSupport">I have experience and am confident</option><option value="needSomeSupport">I have experience, but would like more support</option><option value="willingToLearn">I do not have experience, but am willing to learn</option><option value="needSignificantSupport">I do not have experience and would need significant support</option></Field></FieldGroup>;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
    t17 = <>{t10}{t11}{t12}{t13}{t14}{t15}{t16}</>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
}
function _temp(t_0) {
  return <option key={t_0.id} value={t_0.id}>{`${t_0.value} (${t_0.seasonValue.split(" ")[0]} Quarter)`}</option>;
}
export default Education;